import { useEffect, useMemo, useState } from "react";
import { authWithTelegram, getCurrentUser } from "../api/auth";
import { getTelegramInitData, getTelegramUser, initTelegramUi } from "../api/tg";

const DEV_USER = {
  id: 999000,
  displayName: "Dev User",
  countryCode: "RU",
  city: "",
  avatarUrl: null,
  sports: [],
  photos: [],
  isOnboardingComplete: false,
};

export function useCurrentUser() {
  const [telegramUser] = useState(() => getTelegramUser());
  const [currentUser, setCurrentUser] = useState(null);
  const [loading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    initTelegramUi();
  }, []);

async function login() {
  setError("");
  try {
    const auth = await authWithTelegram();
    setCurrentUser(auth.currentUser);
    return true;
  } catch (e) {
    if (String(e?.message).includes("initData")) {
      setError("Telegram WebApp initData недоступен");
    } else {
      setError("Не удалось авторизоваться через Telegram");
    }
    return false;
  }
}

  async function continueAsDev() {
    setError("");
    try {
      const me = await getCurrentUser(1001);
      setCurrentUser(me);
      return true;
    } catch {
      setCurrentUser(DEV_USER);
      return true;
    }
  }

  async function refreshUser(userId) {
    const me = await getCurrentUser(userId);
    setCurrentUser(me);
    return me;
  }

  const isTelegram = !!telegramUser;

  const user = useMemo(() => currentUser, [currentUser]);

  return {
    loading,
    user,
    telegramUser,
    isTelegram,
    error,
    login,
    continueAsDev,
    refreshUser,
  };
}
